import React from 'react';
import Title from '../../../../../@casino/ui/title';
import {useRouter} from '../../../../../@casino/useRouter';
import { useDispatch, useSelector } from 'react-redux';
import { setGetListExchangeRates } from '../../store/thunk/setGetListExchangeRates';
import Table from '../../../../../@casino/ui/table';

const ExchangeRates = () => {
    const router = useRouter();
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(setGetListExchangeRates())
    }, [])
    const exchangeRates = useSelector(state => state.exchangeRates.list);

    const columns = [
        { id: 'to_currency', label: 'Валюта'},
        { id: 'from_currency', label: 'Валюта'},
        { id: 'value', label: 'Курс'},
        { id: 'change', label: ''}
    ];


    const rows = exchangeRates?.map((item) => {
        return {
            to_currency: item.to_currency,
            from_currency: item.from_currency,
            value: item.value,
            change: <span style={{cursor: 'pointer'}} onClick={() => router.history.push(`/settings/exchange-rates/edit/${item.id}`)}>Изменить</span>
        }
    })

    return (
        <div style={{padding: '0 20px'}}>
            <Title 
                label="Курсы валют" 
                labelBtn="Добавить"
                button={() => router.history.push('/settings/exchange-rates/create')}    
            />
            <div style={{
                padding: 20, 
                background: '#1b2039', 
                borderRadius: 8, 
            }}>
                <Table
                    columns={columns}
                    rows={rows}
                />
            </div>
        </div>
    )
}

export default ExchangeRates;